// This file is auto-generated by dibs-icons script
import { type FC } from 'react';
import ChevronLeft20 from './ChevronLeft20';
import ChevronLeft24 from './ChevronLeft24';
import ChevronLeft40 from './ChevronLeft40';
import ChevronLeft48 from './ChevronLeft48';

type ChevronLeftProps = {
    variation: '20' | '24' | '40' | '48';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    ChevronLeft20,
    ChevronLeft24,
    ChevronLeft40,
    ChevronLeft48,
};

const ChevronLeft: FC<ChevronLeftProps> = ({ variation, ...props }) => {
    const variationKey = `ChevronLeft${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        // eslint-disable-next-line no-console
        console.error(`"ChevronLeft" icon variation ${variationKey} does not exist`);
        return null;
    }

    return <Icon {...props} />;
};

export default ChevronLeft;
